import React, { Component } from "react";
import ShopListWidget from './shop_list_widget';
import {observer, inject} from 'mobx-react';
import Flexbox from 'flexbox-react';
import HallPanelConnectionAlert from '../alerts/hall_panel_connection_alert';

const shopListPanel = {
    "fontSize": "1vh"
};

@inject('RootStore')
@observer
export default class ShopListPanel extends Component {

    render() {
        const className = this.props.RootStore.styleStore.currentStylesDict.hallPanelMainBackgroundClassName || '';
        let shopListWidget = <ShopListWidget/>;
        if(this.props.RootStore.configStore.displayConnectionIssue) {
            shopListWidget = <HallPanelConnectionAlert alertBoxHeight="45%"/>;
        } else {
            shopListWidget = <ShopListWidget/>;
        }
        return (
          <Flexbox width="45%" height="100%" className={className} style={shopListPanel}>
              {shopListWidget}
          </Flexbox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/food_court_shop_list_panel/shop_list_panel.jsx